import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const chartered = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getCharteredBuses() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/chartered`)
  },
  getAvailableCharteredBuses() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/chartered/names`)
  },
  addCharteredBus(chartered) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${chartered.siteId}/chartered`, chartered)
  },
  editCharteredBus(chartered) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${chartered.siteId}/chartered/${chartered.id}`, chartered)
  },
  getSitesWithChartereds() {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/chartereds`)
  },
  getActiveCharteredBusesGroupedBySite(){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/chartereds`)
  },
  activateChartered (chartered) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${chartered.site.id}/chartered/${chartered.id}/activate`, {
      ignoreGlobalCatch: true,
    })
  },
  deactivateChartered (chartered, cancelFutureBookings) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${chartered.site.id}/chartered/${chartered.id}/deactivate?cancelFutureBookings=${cancelFutureBookings}`, {
      ignoreGlobalCatch: true
    })
  },
  getCharteredBusDevices(charteredBusId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/chartered/${charteredBusId}/devices`)
  },
  saveCharteredDevices (charteredBusId, devices, blockAccessUponPriorBooking) {
    const body = { charteredBusId, devices, blockAccessUponPriorBooking }
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/chartered/${charteredBusId}/devices`, body)
  }
}

export default chartered
